import React, { useState, useEffect } from 'react';
import { Title } from '../../../productCatalogueDashboard/css';
import { TdImp } from './css';
import { SectionTitle } from '../discountApprovalSection/css';

const Promotions = ({ mdrPromotions, setMdrPromotions }) => {
  // Initialize state from props
  const [selectedPromos, setSelectedPromos] = useState(() =>
    mdrPromotions.filter(promo => promo.isSelected)
  );

  useEffect(() => {
    // Sync selected promos to mdrPromotions
    const updatedPromos = mdrPromotions.map(promo => ({
      ...promo,
      isSelected: selectedPromos.some(selected => selected.id === promo.id)
    }));
    setMdrPromotions(updatedPromos);
  }, [selectedPromos]);

  const handlePromos = (e, promoObj) => {
    const isChecked = e.target.checked;

    setSelectedPromos(prev => {
      if (isChecked) {
        // Add if not already selected
        return [...prev, promoObj];
      } else {
        // Remove from selection
        return prev.filter(p => p.id !== promoObj.id);
      }
    });
  };

  return (
    <>
      <SectionTitle>Promotions</SectionTitle>
      {mdrPromotions.map(promo => (
        <div key={promo.id} style={{ display: 'flex', alignItems: 'center' }}>
          <input
            style={{
              marginRight: '1rem',
              height: '1.25rem',
              width: '1.25rem',
              borderRadius: '4px'
            }}
            type="checkbox"
            value={promo.label}
            id={`promo-${promo.id}`}
            name={promo.label}
            checked={selectedPromos.some(p => p.id === promo.id)}
            onChange={e => handlePromos(e, promo)}
            disabled={promo.isDisabled}
          />
          {/* eslint-disable-next-line jsx-a11y/label-has-for */}
          <label
            style={{ cursor: promo.isDisabled ? 'not-allowed' : 'pointer' }}
            htmlFor={`promo-${promo.id}`}
          >
            {promo.label}
          </label>
        </div>
      ))}
    </>
  );
};

export default Promotions;
